import React, { useEffect, useState } from "react";
import styles from "./WORform.module.css";
import stepOne from "../../assets/stepone.png";
import stepTwo from "../../assets/stepTwo.png";
import { DatePicker, List, Modal, TimePicker } from "antd";
import { IoRadioButtonOff, IoRadioButtonOn } from "react-icons/io5";
import { FaCalendarAlt } from "react-icons/fa";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "./override.css";
import { AntdDropdown, AntdInput, AntdSubmit } from "../../components";
import { IoIosArrowForward } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { MdClear } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CategoriesMiddleware from "../../store/Middlewares/CategoriesMiddleware";
import WorkOrderRequestMiddleware from "../../store/Middlewares/WorkOrderRequestMiddleware";
import moment from "moment";
import AlertAction from "../../store/Actions/AlertActions";
import TextArea from "antd/es/input/TextArea";
const WORform = () => {


  const { state } = useLocation()
  console.log('state', state)
  // const previousData = state;

  const navigate = useNavigate();
  const [current, setCurrent] = useState(state?.current ? state?.current : 0);
  const [selectedItem, setSelectedItem] = useState();

  const next = () => {
    if (InventoryData && SelectedCategory && SelectedDate && StartTime && selectedLocation) {
      setCurrent(current + 1);
      // onPressStoreAlert()
    }
    else if (SelectedCategory && SelectedDate && StartTime && selectedLocation && !InventoryData) {
      if (window.confirm('Do you want to select the store?')) {
        navigate("/WorkOrderRequestForm/Stores", {
          state: {
            screenName: 'workOrderForm',
          }
        })
      } else {
        setCurrent(current + 1);
        // onPressStoreAlert()
      }

    }
    else {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'All fields are required!' }))
    }


  };

  useEffect(() => {
    getLanguage();
  }, []);

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };

  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const CategoryList = useSelector(
    state => state.CategoriesReducer.CategoryList,
  );
  // console.log('CategoryList',user?.addresses)
  const user = useSelector(state => state.AuthReducer.user);
  console.log('user?.addresses', user?.addresses)

  const [SelectedCategory, setSelectedCategory] = useState(null);

  const [SelectedType, setSelectedType] = useState('');
  const [Refresh, setRefresh] = useState(false);
  const [date, setDate] = useState(new Date());
  const [DateModal, setDateModal] = useState(false);
  const [SelectedDate, setSelectedDate] = useState(null);
  const [StartTimeModal, setStartTimeModal] = useState(false);
  const [StartTime, setStartTime] = useState(null);

  const [Time, setTime] = useState('12:00 AM');

  const [selectedLocation, setselectedLocation] = useState(null);
  const [UrgencyList, setUrgencyList] = useState([
    { id: '1', type: 'Emergency', checked: false },
    { id: '2', type: 'This Week', checked: false },
    { id: '3', type: 'One Day', checked: false },
    { id: '4', type: 'When Possible', checked: false },
  ]);
  const [SelectedUrgency, setSelectedUrgency] = useState('');
  const [ServiceName, setServiceName] = useState('');
  const [ServiceDetails, setServiceDetails] = useState('');
  const [InventoryList, setInventoryList] = useState([
    { id: '1', item: 'Paper Towel', quantity: '01' },
    { id: '2', item: 'Mop', quantity: '05' },
    { id: '3', item: 'Wiper', quantity: '07' },
    { id: '4', item: 'Bucket', quantity: '03' },
  ]);
  const [InventoryData, setInventoryData] = useState(state?.screenName == 'workOrderForm' ? state?.data : null);
  const [StoreLocation, setStoreLocation] = useState(
    'Terminal, 45 Grand Central',
  );

  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = () => {
    dispatch(CategoriesMiddleware.getCategories());
  };

  const onPressUrgencyRadioButton = item => {
    for (let i = 0; i < UrgencyList.length; i++) {
      console.log('i', i)
      console.log('item?.id', item?.id)
      if (i + 1 == item?.id) {

        UrgencyList[i].checked = true;
        setSelectedUrgency(UrgencyList[i].type);
      } else {
        UrgencyList[i].checked = false;
      }
    }
    setRefresh(!Refresh);
  };

  const onPressRequest = () => {
    if (!SelectedCategory || !SelectedDate || !selectedLocation || !SelectedUrgency || !ServiceName || !ServiceDetails || !StartTime) {
      dispatch(AlertAction.ShowAlert({ type: "error", message: 'All fields are required!' }))
    } else {
      let data = {
        SelectedCategory: SelectedCategory,
        SelectedDate: SelectedDate,
        selectedLocation: selectedLocation,
        SelectedUrgency: SelectedUrgency,
        ServiceName: ServiceName,
        ServiceDetails: ServiceDetails,
        StoreID: InventoryData?.storeid,
        LocationID: InventoryData?.Locationid,
        SelectedInventory: InventoryData?.inventory,
        StartTime: StartTime,
      };
      console.log('onPressStoreAlert', data)
      dispatch(WorkOrderRequestMiddleware.CreateJob(data))
        .then(data => {
          navigate('/schedule', {
            state: {
              wofCreatedModal: true
            }
          })
          // alert('Note', data?.message, [
          //   // { text: 'OK', onPress: () => navigation.goBack() },
          // ]);
        })
        .catch(error => console.log(error));

    }
  };


  const renderCategory = (item, index) => {
    console.log('renderCategory', item)
    return (
      <div className={styles.listItem}>
        {item?.id == SelectedCategory ? (
          <IoRadioButtonOn
            onClick={() => setSelectedCategory(item?.id)}
            className={styles.radioIcon}
            color="var(--secondary-color)"
          />
        ) : (
          <IoRadioButtonOff
            onClick={() => setSelectedCategory(item?.id)}
            className={styles.radioIcon}
            color="#ffffff"
          />
        )}
        <p>{item?.name}</p>
      </div>
    );
  };
  const renderUrgency = item => {
    return (
      <div onClick={() => onPressUrgencyRadioButton(item)} className={styles.listItem}>
        {item?.checked ? (
          <IoRadioButtonOn
            // onClick={() => onPressUrgencyRadioButton(item)}
            className={styles.radioIcon}
            color="var(--secondary-color)"
          />
        ) : (
          <IoRadioButtonOff
            // onClick={() => onPressUrgencyRadioButton(item)}
            className={styles.radioIcon}
            color="#ffffff"
          />
        )}
        <p>{item?.type}</p>
      </div>
    );
  };
  const renderInventory = (item, index) => {
    return (
      <div className={styles.I_listItem}>
        <span>{item?.name}</span>
        <p>{item?.quantity}</p>
      </div>
    );
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.heading}>
        <h1>Work Order Request Form</h1>
        <div className={styles.stepper}>
          {current == "0" ? (
            <img src={stepOne} />
          ) : current == "1" ? (
            <img src={stepTwo} />
          ) : null}
        </div>
      </div>
      {current == "0" ? (
        <div className={styles.subMain}>
          <div className={styles.dateInput}>
            <label>Store</label>
            <div className={styles.storeDiv} onClick={() => navigate("/WorkOrderRequestForm/Stores", {
              state: {
                screenName: 'workOrderForm',
              }
            })}>
              <p>Store</p>
              <IoIosArrowForward color="var(--secondary-color)" size={25} />
            </div>
          </div>
          <List
            className={styles.inventoryList}
            style={{ width: "100%" }}
            //   grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
            dataSource={InventoryData?.inventory}
            //   footer={loadMore}
            renderItem={renderInventory}
          />
          <h5>Category</h5>
          <div>
            <List
              style={{ width: "100%" }}
              grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
              dataSource={CategoryList}
              //   footer={loadMore}
              renderItem={renderCategory}
            />
          </div>
          <div className={styles.dateInput}>
            <label>Date</label>
            <DatePicker
              className={`${styles.input} myInput`}
              format={'MM-DD-YYYY'}
              placeholder={SelectedDate
                ? moment(SelectedDate).format('MM-DD-YYYY')
                : t('Select Date')}
              style={{
                height: 45,
              }}
              disabledDate={(current) => {
                let customDate = moment().format("MM-DD-YYYY");
                return current && current < moment(customDate, "MM-DD-YYYY");
              }
              }
              onChange={(date, dateString) => setSelectedDate(moment(dateString).format('YYYY-MM-DD'))}
              suffixIcon={<FaCalendarAlt className={styles.calendarIcon} />}
            //   onChange={(date, dateString) => setdateTo(dateString)}
            />
          </div>
          <div className={styles.dateInput}>
            <label>Time</label>
            <TimePicker
              className={"myTime"}
              use12Hours
              format="h:mm a"
              placeholder={t('Start Time')}
              onChange={(time, timeString) => setStartTime(timeString)}
            />
          </div>
          <div className={styles.dateInput}>
            <label>Location</label>
            <AntdDropdown
              placeholder={"Choose Location"}
              name={"location"}
              className={"select_dropdown"}
              // style={{backgroundColor: '#000000'}}
              //   label={"Location"}

              // onChange={handleChange}
              // options={user?.addresses}
              onChange={(val) => setselectedLocation(val)}
              options={
                user?.addresses?.map((item) => { return ({ value: item?.id, option: item?.address}) })
              }
            />
          </div>
          <div className={styles.btn}>
            <AntdSubmit
              onClick={() => next()}
              text={"Next"}
              buttonStyle={{
                margin: "15px 0px",
                height: "60px",
                width: "100%",
              }}
            />
          </div>
        </div>
      ) : current == "1" ? (
        <div className={styles.subMain}>
          <h5>Urgency</h5>
          <div>
            <List
              style={{ width: "100%" }}
              grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
              dataSource={UrgencyList}
              //   footer={loadMore}
              renderItem={renderUrgency}
            />
          </div>
          <div className={styles.dateInput}>
            <label>Service Name</label>
            <AntdInput
              className={styles.antInput}
              placeholder={"Service Name"}
              name={"service_name"}
              onChange={(e) => setServiceName(e.target.value)}
              rules={[
                {
                  require: true,
                  type: "text",
                  message: "Please enter a service name",
                },
              ]}
            />
          </div>
          <div className={styles.dateInput}>
            <label>Service Details</label>
            <TextArea
              className={styles.antInput}
              rows={4}
              style={{ resize: 'none', backgroundColor: 'transparent', border: '2px solid white', color: 'white' }}
              placeholder={t('Service Details')}
              name={"service_details"}
              onChange={(e) => setServiceDetails(e.target.value)}
              rules={[
                {
                  require: true,
                  type: "text",
                  message: "Please enter a service details",
                },
              ]}
            />
          </div>

          <div className={styles.btn}>
            <AntdSubmit
              // onClick={() => next()}
              onClick={() => onPressRequest()}
              text={"Request"}
              buttonStyle={{
                margin: "15px 0px",
                height: "60px",
                width: "100%",
              }}
            />
          </div>

        </div>
      ) : null}

    </div>
  );
};

export default WORform;
